import React from "react";

type CartItemPropertyProps =
  | {
      name: string;
      value?: string;
      price?: number;
    }
  | {
      name?: string;
      value: string;
      price?: number;
    };

// TEMP SOLUTION FOR CHEW COUNT
const getChewCount = (price: number): number | null => {
  if (price === 67.39) return 90;
  if (price === 46.89) return 60;
  if (price === 29.94) return 30;

  return null;
};

const CartItemProperty = ({ name, value, price }: CartItemPropertyProps) => {
  const chewCount = price ? getChewCount(price) : null;
  const displayName = chewCount && name ? `${name} (${chewCount} chews)` : name;

  return (
    <div className="cart-item__property">
      {displayName && <span className="cart-item__property-name">{displayName}</span>}
      {value && <span className="cart-item__property-value">{value}</span>}
    </div>
  );
};

export default CartItemProperty;
